import React from "react";

import { animated, config, useSpring } from "@react-spring/web";

import ArrowBackward from "@mui/icons-material/ArrowBackIos";
import ArrowForward from "@mui/icons-material/ArrowForwardIos";
import MuiIconButton from "@mui/material/IconButton";
import styled from "@mui/material/styles/styled";

import { Direction } from "@app/analytics/components/ScrollSlider/types";

const IconButton = styled(MuiIconButton)(({ theme }) => ({
  backgroundColor: theme.palette.shades.neutral[100],
  width: "40px",
  height: "40px",
  boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.08)",
  "&:hover": {
    backgroundColor: theme.palette.shades.neutral[50],
  },
  "&:active": {
    backgroundColor: theme.palette.shades.neutral[100],
  },
  "& svg": {
    fontSize: "14px",
    color: theme.palette.shades.neutral[300],
  },
}));

const ScrollSliderButton = ({
  direction,
  onClick,
  show,
}: {
  direction: Direction;
  onClick: (direction: Direction) => void;
  show: boolean;
}) => {
  const { opacity, left, right } = useSpring({
    from: {
      opacity: 0,
      left: "0px",
      right: "0px",
    },
    left: show ? "8px" : "0px",
    right: show ? "8px" : "0px",
    opacity: show ? 1 : 0,
    config: config.stiff,
  });

  return (
    <animated.div
      style={{
        opacity,
        left: direction === "backward" ? left : undefined,
        right: direction === "forward" ? right : undefined,
        position: "absolute",
        top: "calc(50% - 20px)",
      }}
    >
      <IconButton
        disableFocusRipple
        disableRipple
        onClick={() => onClick(direction)}
      >
        {direction === "forward" ? (
          <ArrowForward />
        ) : (
          <ArrowBackward sx={{ marginLeft: "4px" }} />
        )}
      </IconButton>
    </animated.div>
  );
};

export default ScrollSliderButton;
